module.exports = __webpack_public_path__ + "media/images/back-to-home-white-87d45caf44dc1337cc9c2c8e854db42d.svg";